exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fixed-size-button{width:100%;text-align:left}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/panel/outputs.component/styles.less
 ** module id = 616
 ** module chunks = 0
 **/